var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a, _b, _c;
import { APIRequestType, ClientRequestType } from "./types.js";
import "statuses";
import { ChannelEmitter } from "./channel/ChannelEmitter.js";
import "./channel/types.js";
const simulatorClientDefaultOptions = {
  requestIDPrefix: "client-"
};
class SimulatorClient extends ChannelEmitter {
  constructor(target, requestHandlers, options) {
    var _a2, _b2;
    const debug = (options == null ? void 0 : options.debug) || /[?&]debug=true/i.test(decodeURIComponent(window.location.search));
    super(target, {
      [APIRequestType.SetActiveSlice]: (_req, res) => {
        return res.success();
      },
      [APIRequestType.SetSliceZoneSize]: (_req, res) => {
        return res.success();
      },
      ...requestHandlers
    }, {
      ...simulatorClientDefaultOptions,
      ...options,
      debug
    });
    __publicField(this, _a, async () => {
      return await this.postFormattedRequest(ClientRequestType.Ping);
    });
    __publicField(this, _b, async (data) => {
      return await this.postFormattedRequest(ClientRequestType.SetSliceZone, data);
    });
    __publicField(this, _c, async (data) => {
      return await this.postFormattedRequest(ClientRequestType.ScrollToSlice, data);
    });
    if (debug) {
      window.prismic || (window.prismic = {});
      (_a2 = window.prismic).sliceSimulator || (_a2.sliceSimulator = {});
      (_b2 = window.prismic.sliceSimulator).client || (_b2.client = []);
      window.prismic.sliceSimulator.client.push(this);
    }
  }
}
_a = ClientRequestType.Ping, _b = ClientRequestType.SetSliceZone, _c = ClientRequestType.ScrollToSlice;
export {
  SimulatorClient,
  simulatorClientDefaultOptions
};
//# sourceMappingURL=SimulatorClient.js.map
